import { ILatLng } from "polydraw";

export interface IPolygon {
    polygon: ILatLng[][][];
}
/**
 * Polygon storage in SessionStorage.
 */
export class PolygonStorageUtil {

    private static readonly storageName: string = "polyDrawPolygon";
    
    static add(polygon: ILatLng[][][]): number {
        let stored = this.getAll();
        let polyLength: number = 1;
        if (polygon) {
            if (!stored) {
                stored = [];
            }
            polyLength = stored.push({polygon: polygon});
            sessionStorage.setItem(this.storageName, JSON.stringify(stored));
        } else {
            return -1;
        }
        
        return polyLength -1;
    }

    static update(idx: number, polygons: ILatLng[][][]): boolean {
        const storedPolygons = this.getAll();
        if(storedPolygons && storedPolygons.length > idx){
            storedPolygons[idx].polygon = polygons;
            sessionStorage.setItem(this.storageName, JSON.stringify(storedPolygons));
            return true;
        } 
        return false;
    }

    static getAll(): IPolygon[] {
        const stringified = sessionStorage.getItem(this.storageName);
        if (stringified) {
            return JSON.parse(stringified) as IPolygon[];
        } else {
            return null;
        }
    }

    static get(idx: number): ILatLng[][][] {
        const stored = this.getAll();
        if (stored && stored.length > idx) {
            return stored[idx].polygon;
        }
        return null;
    }

    static remove(): void {
        sessionStorage.removeItem(this.storageName);
    }
}